import { api } from "@/lib/api";

export type IntegrationCredentialField = {
  key: string;
  label: string;
  type: "text" | "password" | "url";
  required?: boolean;
  placeholder?: string;
  helpText?: string;
};

export type MarketplaceIntegration = {
  id: string;
  key: string;
  name: string;
  category: string;
  description: string;
  logoEmoji: string | null;
  logoUrl: string | null;
  tags: string[];
  credentialFields: IntegrationCredentialField[];
  recommended: boolean;
  sortOrder: number;
  runtimeReady: boolean;
  createdAt: string;
  updatedAt: string;
};

export type IntegrationConnection =
  | { connected: true; secretId: string; connectedAt: string }
  | { connected: false };

export type CompanyIntegration = MarketplaceIntegration & {
  connection: IntegrationConnection;
};

export const integrationsApi = {
  marketplace: () => api.get<MarketplaceIntegration[]>("/marketplace/integrations"),
  list: (companyId: string) =>
    api.get<CompanyIntegration[]>(`/companies/${companyId}/integrations`),
  connect: (companyId: string, key: string, credentials: Record<string, string>) =>
    api.post<{ listing: MarketplaceIntegration; connection: IntegrationConnection }>(
      `/companies/${companyId}/integrations/${key}/connect`,
      { credentials },
    ),
  /**
   * Valida credenciais persistidas chamando a API do provider.
   * Retorna 200 com `{ ok, accountName }` ou 422 com erro específico.
   */
  test: (companyId: string, key: string) =>
    api.post<{ ok: true; accountName: string } | { ok: false; error: string }>(
      `/companies/${companyId}/integrations/${key}/test`,
      {},
    ),
  disconnect: (companyId: string, key: string) =>
    api.delete<{ ok: true }>(`/companies/${companyId}/integrations/${key}`),
};
